<template>
  <div class="container">
    <div class="left-list">
      <div class="header">
        <el-tooltip placement="right" content="点击刷新歌单">
          <span style="font-weight: bold; cursor: pointer" @click="getCollectionFromServer">我的歌单</span>
        </el-tooltip>
      </div>
      <el-main v-loading="collectionLoading" class="list-main">
        <el-card :class="selectedCollectionId === item.id ? 'active' : ''" shadow="hover" v-for="item in collectionList" :key="item.id">
          <div class="list-item" @click="chooseCollection(item.id, item.name, item.description)">
            <div style="height: 100%; margin-right: 5px">
              <el-image lazy style="height: 100%; width: 50px;" :src="item.cover" alt="">
                <div slot="error" class="image-slot" style="height: 100%; display: flex; align-items: center; justify-content: center">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
            <div style=" width: 100%">
              <div style="font-size: 14px;font-weight: bold; ">
                {{ item.name }}
              </div>
              <span style="font-size: 12px">{{ item.description }}</span>
            </div>
            <i class="el-icon-arrow-right"></i>
          </div>
        </el-card>
        <el-card>
          <el-button type="primary" style="width: 100%" @click="openCollectionDialog('add')">创建歌单</el-button>
        </el-card>
      </el-main>
    </div>
    <div>
      <el-divider direction="vertical"></el-divider>
    </div>
    <div class="right-list">
      <div class="list-top">
        <div class="toolbar">
          <div class="toolbar-left">
            <!--选择播放模式-->
            <el-select v-model="playMode" @change="changePlayMode" title="选择播放模式" placeholder="请选择播放模式" style="margin-right: 10px; width: 120px">
              <el-option
                  v-for="item in playModeOption"
                  :key="item.id"
                  :label="item.name"
                  :value="item.mode" :icon="item.icon">
                <i :class="item.icon" style="margin-right: 5px"></i>
                <span>{{ item.name }}</span>
              </el-option>
            </el-select>
            <el-button @click="playAllSong" type="primary" plain icon="el-icon-play" title="播放当前歌单中所有歌曲">播放全部</el-button>
            <el-button @click="addAllToPlayList" type="primary" plain icon="el-icon-plus" title="将当前歌单或者选中歌曲添加到播放列表">添加到播放列表</el-button>
            <el-button @click="playPreSong" type="primary" plain icon="el-icon-pre" title="上一首"></el-button>
            <el-button @click="playNextSong" type="primary" plain icon="el-icon-next" title="下一首"></el-button>
            <el-button type="success" :disabled="selectedSongs.length === 0" icon="el-icon-plus" @click="openCollectionDialog('song')">添加到歌单</el-button>

          </div>
          <div class="toolbar-right">
            <el-button @click="openCollectionDialog('edit')" type="warning" plain icon="el-icon-edit" title="编辑当前歌单">编辑歌单</el-button>
            <el-button @click="deleteCollection" type="danger" plain icon="el-icon-delete" title="删除当前歌单">删除歌单</el-button>
          </div>
        </div>
        <div>
          <el-divider></el-divider>
        </div>
      </div>
      <div class="list-content">
        <div class="table-content">
          <el-table
              :data="tableData"
              ref="table"
              height="100%"
              key="listTable"
              @selection-change="handleSelectionChange"
              @row-dblclick="playMusic"
              v-loading="getSongInfoListLoading"
              style="width: 100%" stripe>
            <el-table-column
                type="selection"
                width="40">
            </el-table-column>
            <el-table-column
                label="序号"
                type="index" width="50">
            </el-table-column>
            <el-table-column
                prop="songName"
                label="歌曲"
                width="180">
            </el-table-column>
            <el-table-column
                prop="singerName"
                label="歌手"
                width="150">
            </el-table-column>
            <el-table-column
                prop="albumName"
                label="专辑">
            </el-table-column>
            <el-table-column
                prop="duration"
                label="时长" width="100">
            </el-table-column>
            <el-table-column
                label="音质"
                width="150">
              <template slot-scope="scope">
                <template v-if="scope.row.quality === 'normal'">
                  <el-tooltip content="普通音质" placement="bottom">
                    <!--<div slot="content">普通音质<br/>{{ (scope.row.FileSize / (1024*1024)).toFixed(2) }}MB</div>-->
                    <el-tag type="primary">普通</el-tag>
                  </el-tooltip>
                </template>
                <template v-else-if="scope.row.quality === 'HQ'">
                  <el-tooltip placement="bottom" content="HQ音质">
                    <!--<div slot="content">HQ音质<br/>{{ (scope.row.HQFileSize / (1024*1024)).toFixed(2) }}MB</div>-->
                    <el-tag type="success">HQ</el-tag>
                  </el-tooltip>
                </template>
                <template v-else-if="scope.row.quality === 'SQ'">
                  <el-tooltip placement="bottom" content="SQ音质">
                    <!--<div slot="content">SQ音质<br/>{{ (scope.row.SQFileSize / (1024*1024)).toFixed(2) }}MB</div>-->
                    <el-tag type="warning">SQ</el-tag>
                  </el-tooltip>
                </template>
                <template v-else-if="scope.row.quality === 'Res'">
                  <el-tooltip placement="bottom" content="Hi-Res音质">
                    <!--<div slot="content">Hi-Res音质<br/>{{ (scope.row.ResFileSize / (1024*1024)).toFixed(2) }}MB</div>-->
                    <el-tag type="danger">Res</el-tag>
                  </el-tooltip>
                </template>
                <template v-else>
                  <el-tooltip content="普通音质" placement="bottom">
                    <el-tag type="primary">普通</el-tag>
                  </el-tooltip>
                </template>
              </template>
            </el-table-column>
            <el-table-column
                label="平台" width="50">
              <template slot-scope="scope">
                {{ platName(scope.row.platId) }}
              </template>
            </el-table-column>
            <el-table-column
                label="操作"
                width="200" fixed="right">
              <template slot-scope="scope">
                <!--播放-->
                <el-button @click="playMusic(scope.row)" type="primary" title="播放" circle plain icon="el-icon-video-play" size="small"></el-button>
                <!--添加到播放列表-->
                <el-button @click="addToPlayList(scope.row)" type="primary" title="添加到播放列表" circle plain icon="el-icon-plus" size="small"></el-button>
                <!--下载-->
                <el-button @click="download(scope.row.playUrl, scope.row.songName+'_'+scope.row.singerName, scope.row.imgUrl)" type="primary" title="下载" circle plain icon="el-icon-download" size="small"></el-button>
                <el-button @click="deleteSongFromCollection(scope.row)" type="danger" title="将歌曲从歌单里删除" circle plain icon="el-icon-delete" size="small"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <el-pagination style="background: white"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="currentPage"
                     :page-sizes="[10, 20, 30, 50, 80, 100]"
                     :page-size="pageSize"
                     prev-text="上一页"
                     next-text="下一页"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="total">
      </el-pagination>
    </div>

    <!--be showed when download failed-->
    <el-drawer
        :visible.sync="downloadDialogVisible"
        size="50%"
        :modal="false"
        direction="btt">
      <div class="playInfo">
        <el-image
            style="width: 100px; height: 100px" :src="currentMusicItem.albumUrl">
        </el-image>
        <span style="font-size: 20px">{{ currentMusicItem.title }}</span>
        <!-- autoplay 自动播放 -->
        <!-- loop 循环播放 -->
        <!-- preload 用户点击播放才开始下载 -->
        <audio v-if="downloadDialogVisible" :src="this.currentMusicItem.playUrl" controls preload="none"></audio>
      </div>
    </el-drawer>

    <!--create play collection dialog-->
    <el-dialog :title="collectionDialogTitle" :visible.sync="createCollectionDialogVisible"
               width="40%"
               top="20vh"
               v-if="createCollectionDialogVisible"
               @close="closeCollectionDialog"
    >
      <el-form v-loading="collectionLoading" :model="collectionForm" label-width="80px">
        <el-form-item v-if="openCollectionDialogType === 'song'" style="margin-bottom: 22px" label="选择歌单">
          <!--当 openCollectionDialogType === 'song' 时，-->
          <el-select v-model="collectionForm.id" placeholder="请选择歌单" style="width: 320px">
            <el-option v-for="item in collectionList"
                       :label="item.name"
                       :value="item.id"
                       :key="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="openCollectionDialogType !== 'song'" style="margin-bottom: 22px" label="歌单名称"
                      prop="name"
                      :rules="{ required: true, message: '歌单名称不能为空', trigger: 'blur' }"
        >
          <el-input v-model="collectionForm.name" autocomplete="off" style="width: 320px;"></el-input>
        </el-form-item>
        <el-form-item v-if="openCollectionDialogType !== 'song'" style="margin-bottom: 22px" label="歌单描述"
                      prop="description"
        >
          <el-input v-model="collectionForm.description" autocomplete="off" style="width: 320px; margin-right: 20px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeCollectionDialog">取 消</el-button>
        <el-button type="primary" @click="submitCollectionOperate">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import {
  addCollection, addSongInfo,
  deleteCollection,
  deleteSongInfo,
  getCollection,
  getSongInfoList,
  updateCollection
} from "../../api/music";
import {download} from "../../util/download";

export default {
  name: "MusicList",
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0,

      collectionLoading: false,
      collectionList: [],
      tableData: [],

      selectedCollectionId: 0,
      selectedCollectionName: '',
      selectedCollectionDesc: '',

      createCollectionLoading: false,
      createCollectionDialogVisible: false,
      collectionForm: {},
      // 编辑时使用
      collectionFormName: '',
      collectionFormDesc: '',

      getSongInfoListLoading: false,

      currentMusicItem: {},

      selectedSongs: [],

      downloadDialogVisible: false,

      // 播放模式选择
      playModeOption: [
        {
          id: 1,
          mode: 'list',
          name: '顺序播放',
          icon: 'el-icon-play-list',
          desc: '播完列表歌曲即停止'
        },
        {
          id: 2,
          mode: 'repeat-list',
          name: '列表循环',
          icon: 'el-icon-repeat-list',
          desc: '循环播放列表歌曲'
        },
        {
          id: 3,
          mode: 'repeat-one',
          name: '单曲循环',
          icon: 'el-icon-repeat-one',
          desc: '重复播放当前歌曲'
        },
        {
          id: 4,
          mode: 'random',
          name: '随机播放',
          icon: 'el-icon-random',
          desc: '随机播放列表中的一首歌曲'
        },
      ],
      playMode: 'list',

      // 打开歌单对话框的操作类型： add 添加  edit 编辑  song 添加歌曲到歌单 默认为add
      openCollectionDialogType: 'add',
      collectionDialogTitle: '创建歌单',
    }
  },
  methods: {
    // 选择播放模式
    changePlayMode(mode) {
      this.$store.commit('music/setPlayMode', mode)
    },
    // 选择歌单
    chooseCollection(id, name, desc) {
      this.selectedCollectionId = id
      this.selectedCollectionName = name
      this.selectedCollectionDesc = desc
      this.getSongInfoListByCollectionId(id)
    },

    // 设置store中的配置
    musicCommit(collectionList) {
      this.$store.commit('music/setCollectionList', collectionList)
    },

    // 分页
    handleSizeChange(val) {
      this.pageSize = val
      // 更改页大小后，从第一页开始
      this.currentPage = 1
      this.getSongInfoListByCollectionId(this.selectedCollectionId)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getSongInfoListByCollectionId(this.selectedCollectionId)
    },

    // 查询歌单数据
    getCollection() {
      this.collectionLoading = true
      // 先从本地获取 判断本地是否有歌单数据
      const localCollectionList = this.musicStore.collectionList
      if (localCollectionList) {
        this.collectionList = localCollectionList
        this.selectedCollectionId = this.collectionList[0].id
        // 获取歌单对应歌曲
        this.getSongInfoListByCollectionId(this.selectedCollectionId)
        this.collectionLoading = false
        return
      }
      this.getCollectionFromServer()
    },

    // 从服务器获取歌单数据
    getCollectionFromServer() {
      this.collectionLoading = true
      // 从服务器获取
      getCollection().then(res=>{
        const data = res.data
        if (!data.success) {
          this.$message.error('获取歌单失败')
          return
        }
        const list = data.data
        this.collectionList = list;
        // 有数据， 保存到本地
        if (list.length > 0) {
          this.musicCommit(list)
          this.selectedCollectionId = this.collectionList[0].id
          // this.$message.success('获取歌单成功')
          // this.$notify.success('获取歌单成功')
          // 获取歌单对应歌曲
          this.getSongInfoListByCollectionId(this.selectedCollectionId)
        }
        this.collectionLoading = false
      })
    },

    // 打开编辑歌单对话框，传参为操作类型：可选值：add  edit  song
    openCollectionDialog(operateType) {
      this.openCollectionDialogType = operateType
      if (operateType === 'add') {
        this.collectionDialogTitle = '创建歌单'
      } else if (operateType === 'edit') {
        this.collectionDialogTitle = '编辑歌单'
        this.collectionForm.name = this.selectedCollectionName
        this.collectionForm.description = this.selectedCollectionDesc
        // 将表单数据通过Object.assign方法变为响应式的，否则在打开编辑歌单对话框后，表单内容无法被修改，被固定成了上面两行设置的值
        this.collectionForm = Object.assign({}, this.collectionForm)
      } else if (operateType === 'song') {
        this.collectionDialogTitle = '选择歌单'
      }
      this.createCollectionDialogVisible = true;
    },

    // 提交创建/修改歌单表单
    submitCollectionOperate() {
      // 添加歌单
      if (this.openCollectionDialogType === 'add') {
        // 涉及到异步操作，所以关闭对话框之类的操作就在函数内自己关闭
        this.createCollection()
      } else if (this.openCollectionDialogType === 'edit') {
        // 编辑歌单
        this.editCollection()
      } else if (this.openCollectionDialogType === 'song') {
        // 添加歌曲到歌单
        this.submitAddToCollection()
      }
    },
    // 创建歌单
    createCollection() {
      this.createCollectionLoading = true
      // 准备歌单对象
      const songInfo = {
        name: this.collectionForm.name,
        description: this.collectionForm.description
      }
      addCollection(songInfo).then(res => {
        const data = res.data
        if (!data.success) {
          this.$message.error('创建歌单失败！')
          return
        }
        // this.$message.success('创建成功')
        this.$notify.success('创建歌单成功')
        // 添加成功后会返回id
        const newCollectionItem = {
          id: data.data,
          name: this.collectionForm.name,
          description: this.collectionForm.description
        }
        this.collectionList.push(newCollectionItem)

        this.selectedCollectionId = newCollectionItem.id
        this.selectedCollectionName = newCollectionItem.name
        this.selectedCollectionDesc = newCollectionItem.description

        // 将选择数据保存到本地，下次直接从本地取
        this.musicCommit(this.collectionList)
        this.closeCollectionDialog()

        // 查询歌单中歌曲数据
        this.getSongInfoListByCollectionId(this.selectedCollectionId)
      })
    },

    // 编辑歌单
    editCollection() {
      this.createCollectionLoading = true
      // 准备歌单对象
      const collectionItem = {
        id: this.selectedCollectionId,
        name: this.collectionForm.name,
        description: this.collectionForm.description
      }
      // 请求接口
      updateCollection(collectionItem).then(res=>{
        const data = res.data
        if (!data.success) {
          this.$message.error('修改歌单失败')
        }
        this.$notify.success('修改歌单成功')
        // 这里可以直接从服务端查询新的歌单数据，但是会刷新整个歌单，会选中第一个，感觉有点不好
        // 把原来的删除后，再添加新的这个
        const index = this.collectionList.findIndex((item)=>{
          return item.id === this.selectedCollectionId
        })
        // 使用splice方法，从上面找到的item所在index开始，删除一个，并从当前位置添加一个新的。这样可以保证修改后本地的list中元素位置不变
        this.collectionList.splice(index, 1, collectionItem)
        // 将选择数据保存到本地，下次直接从本地取
        this.musicCommit(this.collectionList)

        this.selectedCollectionName = this.collectionForm.name
        this.selectedCollectionDesc = this.collectionForm.description

        this.closeCollectionDialog()
      })
    },

    // 关闭创建/编辑歌单对话框
    closeCollectionDialog() {
      this.createCollectionDialogVisible = false;
      this.createCollectionLoading = false
      this.collectionForm.name = ''
      this.collectionForm.description = ''
    },

    // 根据歌单获取歌曲列表
    getSongInfoListByCollectionId(collectionId) {
      this.getSongInfoListLoading = true
      const queryParam = {
        collectionId: collectionId,
        pageNum: this.currentPage,
        pageSize: this.pageSize
      }
      getSongInfoList(queryParam).then(res=>{
        // console.log(res)
        const data = res.data
        if (!data.success) {
          this.$message.error('获取歌曲失败')
          return
        }
        // this.$message.success('获取歌曲成功')
        // this.$notify.success('获取歌曲成功')
        this.tableData = data.data.list
        this.total = data.data.total
        this.getSongInfoListLoading = false
      })
    },

    // 选中表格数据
    handleSelectionChange(selection) {
      this.selectedSongs = selection
    },

    // 将选中数据添加到歌单
    async submitAddToCollection() {
      // 将选中的歌曲的歌单id设置为选择的歌单id
      this.selectedSongs.forEach((item)=>{
        item.id = null
        item.collectionId = this.collectionForm.id
      })
      // 发送请求，将数据发送到后端
      await addSongInfo(this.selectedSongs).then(res=>{
        const data = res.data
        if (!data.success) {
          this.$message.error(data.msg)
          return
        }
        // 如果有data，说明有部分是没有添加成功的
        if (data.data) {
          // this.$message.warning('部分添加成功！未添加成功的数据请看控制台')
          this.$notify.warning('部分添加成功！未添加成功的数据请看控制台')
        } else {
          // this.$message.success(data.msg)
          this.$notify.success(data.msg)
        }
      })

      // 等待响应成功，关闭弹窗
      this.closeCollectionDialog()
    },

    // 播放
    playMusic(row) {
      // 返回vueAplayer播放器的数据
      const musicItem = this.convertSongInfoToMusicItem(row)
      // 使用全局事件总线传数据到播放组件
      this.$bus.$emit('playMusic', musicItem)
    },

    // 播放全部（全部加入播放列表中）
    playAllSong() {
      this.addAllToPlayList()
      // 从当前的第一个开始播放
      const musicItem = this.convertSongInfoToMusicItem(this.tableData[0])
      this.$bus.$emit('playMusic',musicItem)
    },

    // 添加到播放列表
    addToPlayList(row) {
      const musicItem = this.convertSongInfoToMusicItem(row)
      this.$store.commit('music/addPlayListItem', musicItem)
      this.$notify.success('已添加到播放列表')
    },
    // 全部添加到播放列表
    addAllToPlayList() {
      if (this.selectedSongs.length === 0) {
        this.tableData.forEach((row)=>{
          const musicItem = this.convertSongInfoToMusicItem(row)
          this.$store.commit('music/addPlayListItem', musicItem)
        });
        this.$notify.success('当前歌单已添加到播放列表')
      } else {
        this.selectedSongs.forEach((row)=>{
          const musicItem = this.convertSongInfoToMusicItem(row)
          this.$store.commit('music/addPlayListItem', musicItem)
        });
        this.$refs.table.clearSelection();
        this.$notify.success('选中歌曲已添加到播放列表')
      }
      // this.$message.success('当前歌单已添加到播放列表')
    },

    // 播放上一首
    playPreSong() {
      this.$bus.$emit('playPre')
    },
    // 播放下一首
    playNextSong() {
      this.$bus.$emit('playNext')
    },

    // 删除当前歌单
    deleteCollection() {
      this.$confirm('确认删除歌单【'+this.selectedCollectionName+'】吗？删除后歌单内歌曲将被删除！','删除歌单', {
        confirmButtonText: '确定删除',
        cancelButtonText: '我再想想',
        type: 'warning'
      }).then(()=>{
        deleteCollection(this.selectedCollectionId).then(res=>{
          const data = res.data
          if (!data.success) {
            this.$message.error('删除歌单失败！')
            return
          }
          this.$notify.success('删除歌单成功')
          // 刷新歌单列表
          this.getCollectionFromServer()
        })
      }).catch(()=>{})
    },

    // 将歌曲从歌单中删除
    deleteSongFromCollection(row) {
      this.$confirm('确认将歌曲【'+row.songName+'】从歌单内删除吗？', '提示', {
        confirmButtonText: '确认删除',
        cancelButtonText: '容我三思',
        type: 'warning'
      }).then(()=>{
        deleteSongInfo(row.id).then(res=>{
          const data = res.data
          if (!data.success) {
            this.$message.error(data.msg)
            return
          }
          this.$notify.success(data.msg)
          // 刷新歌单内容
          this.getSongInfoListByCollectionId(row.collectionId)
        })
      })
    },

    // 将SongInfo转为 vueAplayer播放器的数据
    convertSongInfoToMusicItem(row) {
      return {
        audioId: row.songId,
        title:  row.songName,
        artist: row.singerName,
        src: row.playUrl,
        pic: row.imgUrl,
        lrc: row.lyrics,
        album: row.albumName,
        quality: row.quality
      }
    },

    /**
     * 使用axios下载
     * @param downUrl url
     * @param fileName name
     * @param albumUrl albumUrl
     */
    download(downUrl, fileName, albumUrl) {
      this.currentMusicItem.albumUrl = albumUrl
      this.currentMusicItem.title = fileName
      this.currentMusicItem.playUrl = downUrl

      download(downUrl, fileName, 'mp3', ()=>{
        this.downloadDialogVisible = true;
      })
    },
    // 根据id获取平台名称
    platName(id) {
      const plat = this.$store.state.music.platInfoList.find(item => item.id === id)
      if (plat) {
        return plat.description
      }
      return ''
    }
  },

  computed: {
    musicStore() {
      return this.$store.state.music
    },
  },

  mounted() {
    this.getCollection()
  },

  beforeDestroy() {
    this.$bus.$off('playMusic')
    this.$bus.$off('playPre')
    this.$bus.$off('playNext')
  }

}
</script>

<style lang="less" scoped>
.container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: 100%;

  .left-list {
    min-width: 250px;
    padding: 5px;
    display: flex;
    flex-direction: column;

    .header {
      text-align: center;
      margin: 5px
    }

    /* 隐藏Chrome、Safari 和 Opera (Edge)的滚动条 */
    .list-main::-webkit-scrollbar {
      display: none;
    }

    .list-main {
      height: 100%;
      overflow-y: auto;
      /* 隐藏滚动条 IE and Edge */
      -ms-overflow-style: none;
      /* 隐藏滚动条 Firefox */
      scrollbar-width: none;

      .el-card {
        margin: 5px;
        cursor: pointer;

        /deep/ .el-card__body {
          //display: flex;
          //flex-direction: row;
          //align-items: center;
          height: 100%;
          padding: 5px;

          .list-item {
            display: flex;
            flex-direction: row;
            align-items: center;
            height: 50px;
          }
        }
      }
    }
  }
  // 分割线
  .el-divider--vertical {
    height: 100%;
    margin: 0;
  }

  //.right-list {
  //  width: 100%;
  //  padding: 5px;
  //  display: flex;
  //  flex-direction: column;
  //
  //  .toolbar {
  //    display: flex;
  //    justify-content: space-between;
  //    align-items: center;
  //    //margin: 5px;
  //
  //    .toolbar-left {
  //      width: 100%;
  //      display: flex;
  //      justify-content: flex-start;
  //      align-items: center;
  //      //margin: 5px;
  //    }
  //
  //    .toolbar-right {
  //      width: 100%;
  //      display: flex;
  //      justify-content: flex-end;
  //      align-items: center;
  //      padding: 0 5px 0 0;
  //    }
  //  }
  //
  //  .el-divider--horizontal {
  //    margin: 3px 0;
  //  }
  //}

  .right-list {
    display: flex;
    flex-direction: column;

    width: 100%;
    padding: 5px;

    .list-top {
      .toolbar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        //margin: 5px;

        .toolbar-left {
          width: 100%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          //margin: 5px;
        }

        .toolbar-right {
          width: 100%;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          padding: 0 5px 0 0;
        }
      }

      .el-divider--horizontal {
        margin: 3px 0;
      }
    }

    .list-content {
      flex: 1;
      position: relative;

      .table-content {
        position: absolute;
        width: 100%;
        height: 100%;
      }
    }

  }
}

.el-main {
  padding: 0;
}
// 歌单选择
.active {
  background: #BED2D2FF;
}

// 下载弹窗
.playInfo {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
